import React, { Component } from 'react';
import styled from 'styled-components';
import PlayerHeader from './PlayerHeader';
import PropTypes from 'prop-types';

const Content = styled.div`
    margin-top: 30px;
`;

class PlayerHostSMB extends Component {
    state = {
        playerId: (this.props.params && this.props.params.playerId) || '',
        player: {}
    };

    componentDidMount() {
        this.loadData(this.props.params);
    }

    componentWillReceiveProps({ params }) {
        if (params.playerId !== this.state.playerId) {
            this.loadData(params);
        }
    }

    loadData({ playerId = '' }) {
        Promise.all([fetch(`https://ss2.si-ab.com/players/${playerId}/profile`).then(res => res.json())]).then(
            res => {
                if (res) {
                    const [player = {}] = res;

                    this.setState({
                        playerId,
                        player
                    });
                }
            }
        );
    }

    render() {
        const { playerId = '', player = {} } = this.state;
        const { tournamentId = '', seasonId = '', teamId = '' } = this.props.params;

        return (
            <Content>
                <PlayerHeader
                    playerId={playerId}
                    player={player}
                    tournamentId={tournamentId}
                    seasonId={seasonId}
                    teamId={teamId}
                />
                {this.props.children}
            </Content>
        );
    }
}

PlayerHostSMB.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired
    }).isRequired,
    children: PropTypes.any
};

export default PlayerHostSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/PlayerHostSMB.js
 **/